import React from 'react'
import { ICON_PARK_COMPONENTS } from './iconParkMap'

const SIZES = { xs: 14, sm: 16, md: 20, lg: 24, xl: 28 }

function parkStrokeWidth(px) {
  if (px <= 14) return 3
  if (px <= 20) return 4
  return 4
}

export default function RsIcon({
  name,
  size = 'md',
  className = '',
  strokeWidth,
  spin,
  ...props
}) {
  const px = typeof size === 'number' ? size : SIZES[size] || 20
  const ParkIcon = ICON_PARK_COMPONENTS[name] || ICON_PARK_COMPONENTS.info

  return (
    <ParkIcon
      theme="outline"
      size={px}
      fill="currentColor"
      strokeWidth={strokeWidth ?? parkStrokeWidth(px)}
      strokeLinecap="round"
      strokeLinejoin="round"
      spin={spin}
      className={`rs-icon ${className}`.trim()}
      aria-hidden={props['aria-label'] ? undefined : true}
      {...props}
    />
  )
}

export function IconBadge({ name, tone = 'blue', size = 'md', className = '' }) {
  return (
    <span className={`rs-icon-badge rs-icon-badge--${tone} ${className}`.trim()}>
      <RsIcon name={name} size={size} />
    </span>
  )
}

export function IconLabel({ name, children, size = 'sm', className = '', gap = 6 }) {
  return (
    <span className={`rs-icon-label ${className}`.trim()} style={{ gap }}>
      <RsIcon name={name} size={size} />
      <span>{children}</span>
    </span>
  )
}

export function ModalClose({ className = 'admin-modal-close', onClick, disabled, label = 'Close', ...props }) {
  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      {...props}
    >
      <RsIcon name="close" size="sm" />
    </button>
  )
}

export function resolveIconNode(icon, iconProps = {}) {
  if (!icon) return null
  if (typeof icon === 'string') return <RsIcon name={icon} {...iconProps} />
  if (React.isValidElement(icon)) return icon
  if (typeof icon === 'function') {
    const Comp = icon
    return <Comp {...iconProps} />
  }
  return icon
}
